// Polling que respeita a aba ESCONDIDA.
//
// [2026-10-15] O menu, a home e o Início perguntavam ao servidor a cada minuto
// mesmo com a aba do navegador em segundo plano — com o cockpit aberto em
// várias abas (é o normal no escritório), cada aba esquecida seguia montando a
// fila do WhatsApp e a matriz da DCTFWeb no servidor sem ninguém olhando.
//
// Regra: com a aba escondida o relógio NÃO chama `fn`. Quando a aba volta a
// aparecer, chama na hora se o último carregamento tiver mais de `ms` (quem
// volta ao cockpit vê número fresco, sem esperar o próximo tique).
//
// Sem React de propósito: o harness do backend importa este arquivo no CI,
// onde o frontend não tem node_modules.

export function abaVisivel() {
  try { return typeof document === 'undefined' || document.visibilityState !== 'hidden'; } catch (_) { return true; }
}

/**
 * Liga o polling. Devolve a função de desligar (útil fora do React).
 * @param fn       o que carregar
 * @param ms       intervalo entre carregamentos com a aba visível
 * @param opts.imediato  carrega já na montagem (default true)
 */
export function iniciarPollingVisivel(fn, ms, { imediato = true } = {}) {
  let ultimo = 0;
  const rodar = () => { ultimo = Date.now(); try { fn(); } catch (_) { /* quem chama trata */ } };
  if (imediato) rodar();
  const t = setInterval(() => { if (abaVisivel()) rodar(); }, ms);
  const aoMudar = () => { if (abaVisivel() && Date.now() - ultimo >= ms) rodar(); };
  try { document.addEventListener('visibilitychange', aoMudar); } catch (_) { /* sem DOM */ }
  return () => {
    clearInterval(t);
    try { document.removeEventListener('visibilitychange', aoMudar); } catch (_) { /* sem DOM */ }
  };
}
